import { render, staticRenderFns } from "./topbarGoPositionsList.vue?vue&type=template&id=44da7ad9&"
import script from "./topbarGoPositionsList.vue?vue&type=script&lang=js&"
export * from "./topbarGoPositionsList.vue?vue&type=script&lang=js&"
import style0 from "./topbarGoPositionsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports